module.exports = __webpack_public_path__ + "img/035.96db15dc.png";